import React from "react";

export default function RozsireneMoznostiKarta({
  ppOpen,
  setPpOpen,
  invOpen,
  setInvOpen,
  skalRezim,
  setSkalRezim,
}) {
  return (
    <div className="card-section card-section--rozsirene">
            <h2>Rozšírené možnosti:</h2>

            <div className="toggle-group rozsirene-toggles">
              <label className="chk">
                Predčasné splatenie:
                <input
                  type="checkbox"
                  checked={ppOpen}
                  onChange={(e) => setPpOpen(e.target.checked)}
                />
              </label>

              <label className="chk">
                Investovanie:
                <input
                  type="checkbox"
                  checked={invOpen}
                  onChange={(e) => setInvOpen(e.target.checked)}
                />
              </label>

              <div className="toggle-group rozsirene-kalendar">
                <span className="rozsirene-kalendar-label">Splátkový kalendár:</span>

                <label className="chk">
                  <input
                    type="checkbox"
                    checked={skalRezim === "mesiace"}
                    onChange={() => setSkalRezim(skalRezim === "mesiace" ? null : "mesiace")}
                  />
                  Mesiace
                </label>

                <label className="chk">
                  <input
                    type="checkbox"
                    checked={skalRezim === "roky"}
                    onChange={() => setSkalRezim(skalRezim === "roky" ? null : "roky")}
                  />
                  Roky
                </label>
              </div>
            </div>
          </div>
  );
}